module.exports = "/assets/data/52eb75439b3dabd5d4a2b5892d1c3bc5-EC2V.data.json";